export default __webpack_public_path__ + "static/media/element_69.0c52b7de.webp";